import React from 'react'
import { Helmet } from 'react-helmet'
import TypedText from './Typedtext'
import { Link } from 'react-router-dom'

import sc15 from '../assets/sc15.png'
import sc18 from '../assets/sc18.png'
import sc17 from '../assets/sc17.png'
import sc20 from '../assets/sc20.png'
import me from '../assets/me1.jpg'
import { Github, ExternalLink } from 'lucide-react';
import { FaGithub } from 'react-icons/fa'
import { FiExternalLink } from "react-icons/fi";

const Home = () => {


  const recentProjects = [
    {
      title: "Click Resume",
      desc: "Click Resume analyzes your resume and calculates an ATS score to optimize it for job applications.",
      image: sc15,
      tech: ['React', 'Node.js', 'Express', 'MongoDB', 'Scikit Learn', 'Flask', 'Gemini API', 'NLP'],
      github: "https://github.com/Paresh-ch-Pothal/Click-Resume",
      live: "https://clickresume.vercel.app/"
    },
    {
      title: "Crop Yield Prediction Model",
      desc: "A crop yield prediction model uses data like weather and soil conditions to estimate harvest output, helping farmers plan better.",
      image: sc17,
      tech: ['Streamlit', 'Scikit-Learn', 'Pandas', 'Matplotlib', 'Numpy'],
      github: "https://github.com/Paresh-ch-Pothal/Crop-Yield-Prediction",
      live: "https://crop-yield-sys.streamlit.app/"
    },
    {
      title: "BUzzY : A Smart Bus Booking System",
      desc: "A smart bus booking system that allows users to search, book, and manage bus tickets online with ease and efficiency.",
      image: sc18,
      tech: ['React', 'Node.js', 'Express', 'MongoDB', 'TypeScript', 'Tailwind'],
      github: "https://github.com/Paresh-ch-Pothal/BUzzY---A-Smart-Bus-Booking-System",
      live: "https://b-uzz-y-a-smart-bus-booking-system.vercel.app/"
    },
    {
      title: "Chase The Cloud : Cloud Motion Detection`",
      desc: "Built a ConvLSTM model to predict the next satellite cloud frame by learning spatiotemporal patterns from 10 previous frames.",
      image: sc20,
      tech: ['Tensorflow', 'Keras', 'ConvLSTM', 'Numpy', 'Matplotlib'],
      github: "https://github.com/Paresh-ch-Pothal/Cloud-Motion-Detection_ConvLSTM",
    },

  ];

  const getRandomColor = () => {
    const colors = [
      'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500',
      'bg-red-500', 'bg-pink-500', 'bg-indigo-500', 'bg-teal-500',
      'bg-gray-500', 'bg-yellow-400',
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <>
      <div>
        <Helmet>
          <title>Paresh Chandra Pothal | Portfolio</title>
          <meta name="description" content="Welcome to the portfolio of Paresh Chandra Pothal. Explore projects and skills in AI, Machine Learning, and Full-Stack Development." />
          <meta name="keywords" content="Paresh Chandra Pothal, portfolio, AI, Machine Learning, Full-Stack Development, MERN stack, projects, web development" />
          <meta name="author" content="Paresh Chandra Pothal" />
        </Helmet>


        <section style={{ backgroundColor: "rgba(21, 21, 21, 1)" }} className="text-gray-40 body-font">
          <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
            <div className="lg:max-w-lg lg:w-72 md:w-1/2 w-5/6 md:mb-0 mb-10">
              <img style={{ borderRadius: "20px" }} className="object-cover object-center rounded" alt="hero" src={me} />
            </div>
            <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-red-700">Hello, Myself Paresh
                <br className="hidden lg:inline-block" />
              </h1>
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white"><TypedText /></h1>
              <p className="mb-8 leading-relaxed text-white">Hi, a Computer Science student at IIIT Bhubaneswar with a passion for AI and full-stack development. I enjoy creating innovative solutions and have worked on projects like a real-time chat management system and a weather app using the MERN stack. I’m excited about continuous learning and exploring new technologies. Let’s connect and see how we can collaborate!</p>
              <div className="flex justify-center">
                <Link to={'https://github.com/Paresh-ch-Pothal'} className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">Visit Github</Link>
                <a href='https://www.dropbox.com/scl/fi/l0gszbmaw9b2n5mqd0824/Paresh-Chandra-Pothal-Resume.pdf?rlkey=8yg6a2ksnh89ca2mhizq60kfh&st=p3s1v3h0&dl=0' download={"Paresh_Chandra_Pothal_Resume.pdf"} className="ml-4 inline-flex text-gray-400 bg-gray-600 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">Download Resume</a>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section style={{ backgroundColor: "rgba(21, 21, 21, 1)" }} className="text-gray-400 body-font">
        <div className="flex flex-wrap -m-4">
          {recentProjects.map((project, index) => (
            <div key={index} className="xl:w-1/4 md:w-1/2 p-4">
              <div className="bg-gray-800 bg-opacity-40 p-6 rounded-lg flex flex-col" style={{ height: "100%" }}>
                <img className="h-40 rounded w-full object-cover object-center mb-6" src={project.image} alt={project.title} />
                <h2 className="text-lg text-green-400 font-medium title-font mb-4">{project.title}</h2>
                <p className="leading-relaxed text-base">{project.desc}</p>

                <div className="flex flex-wrap mt-4">
                  {project.tech.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className={`${getRandomColor()} text-white text-xs font-bold py-1 px-2 rounded-full mr-2 mb-2 break-words max-w-full`}
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="mt-4 flex space-x-4">
                  <a
                    href={project.github}
                    className="inline-flex items-center text-sm bg-black hover:bg-gray-700 text-white font-semibold py-2 px-3 rounded transition"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub className="w-4 h-4 mr-2" />
                    GitHub
                  </a>
                  {project.live && (
                    <a
                      href={project.live}
                      className="inline-flex items-center text-sm bg-black hover:bg-gray-700 text-white font-semibold py-2 px-3 rounded transition"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiExternalLink className="w-4 h-4 mr-2" />
                      Live Preview
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}

export default Home
